import type { buckets } from "$/modules/appwrite/lib/appwrite-buckets";
import { replaceFile, uploadFile } from "./storage";

export const getAssetId = async (
	bucketId: keyof typeof buckets,
	currentAssetId?: string,
	newAsset?: File,
	publicRead?: boolean,
) => {
	if (currentAssetId && !newAsset?.size) return currentAssetId;
	if (!currentAssetId && newAsset?.size === 0) return null;
	if (!currentAssetId && newAsset) {
		return await uploadFile({
			bucketId: bucketId,
			asset: newAsset,
			publicRead,
		});
	}

	if (currentAssetId && newAsset) {
		return await replaceFile({
			bucket: bucketId,
			assetId: currentAssetId,
			newAsset: newAsset,
			publicRead,
		});
	}

	return null;
};
